import {AttrsSchema, Component} from 'panel';

import {parseNumber} from 'common/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {StepsType, UpdateStepsValueEvent} from './types';
import css from './index.inline.styl';
import {template} from './template';

interface NumberOfStepsDropdownJsxProps {
  attrs?: {
    'committed-before-steps'?: number;
    'committed-after-steps'?: number;
  };
}

export class NumberOfStepsDropdown extends Component<NumberOfStepsDropdownJsxProps['attrs']> {
  private beforeInput: HTMLInputElement = undefined;

  static get attrsSchema(): AttrsSchema<NumberOfStepsDropdownJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      'committed-before-steps': `number`,
      'committed-after-steps': `number`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      helpers: {
        getStepsLabelForType: (type: StepsType): string => {
          return type === StepsType.Before ? `Before` : `After`;
        },
        handleInputUpdate: (ev, type: StepsType, oldValue: string) => {
          const updatedValue: number = parseNumber(ev.detail.value);
          if (updatedValue === null) {
            (ev.target as HTMLInputElement).value = oldValue;
          } else {
            // Send the updated steps values to the owning selector.
            this.dispatchEvent(
              new CustomEvent(`updateStepsValue`, {
                detail: {
                  type,
                  steps: updatedValue,
                },
              } as UpdateStepsValueEvent),
            );
          }
        },
      },
    };
  }

  focus() {
    this.beforeInput?.focus();
  }

  setBeforeInputRef(elm: HTMLInputElement) {
    this.beforeInput = elm;
  }
}

export const NumberOfStepsDropdownEl = defineAndMakeJsxFactory<NumberOfStepsDropdownJsxProps>(
  `mp-number-of-steps-dropdown`,
  NumberOfStepsDropdown,
);
export const NumberOfStepsDropdownReact = panel2react<NumberOfStepsDropdownJsxProps>(
  `mp-number-of-steps-dropdown`,
  NumberOfStepsDropdown,
);
